export default __webpack_public_path__ + "static/media/IMG_4969.96bf6931.png";